import { Rect } from '../../../platform/geom/Rect';
import { TextRuler } from '../../canvas/visualization/TextRuler';
import { Frame } from './Frame';
import { FrameLabelFontSizeAttr } from './FrameAssociations';
import { FrameTitleFieldTextSettings } from './FrameTitleField';

export const FrameLayout = (frame: Frame) => {
    const { width, height } = frame;

    const base = new Rect(0, 0, width, height);

    const badgeHeight = FrameLabelFontSizeAttr.get(frame);

    const titleTextSize = TextRuler.measureSize(frame.title, FrameTitleFieldTextSettings(frame));
    const titleHeight = titleTextSize.h * 1;
    const titleTop = frame.titleVisible ? -titleHeight - (titleHeight / 2) : 0;

    // const icon = new Rect(0, badgeTop, badgeHeight, badgeHeight);
    const title = new Rect(0, titleTop, Math.min(width, titleTextSize.w + badgeHeight), titleHeight);

    // DebugOverlay.rect(frame.id, title.offset(frame.position(RelativeTo.Model)));

    return { base, title };
};

export type FrameLayout = ReturnType<typeof FrameLayout>;
